import type { EquipmentCategoryFormValues, EquipmentFormValues } from '@oficina/shared';
import { api } from '@/lib/api';
import type { Equipment, EquipmentCategory, EquipmentHistory, Paginated, RemovalResult } from '@/types/api';

export interface EquipmentListParams {
  search?: string;
  clientId?: string;
  categoryId?: string;
  page?: number;
  pageSize?: number;
  includeInactive?: boolean;
}

export const equipmentService = {
  list: (params: EquipmentListParams, signal?: AbortSignal) =>
    api.get<Paginated<Equipment>>('/equipment', { ...params }, signal),
  get: (id: string) => api.get<Equipment>(`/equipment/${id}`),
  history: (id: string) => api.get<EquipmentHistory>(`/equipment/${id}/history`),
  create: (input: EquipmentFormValues) => api.post<Equipment>('/equipment', input),
  update: (id: string, input: Partial<EquipmentFormValues>) => api.patch<Equipment>(`/equipment/${id}`, input),
  remove: (id: string, hard = false) => api.delete<RemovalResult>(`/equipment/${id}`, { hard }),
  reactivate: (id: string) => api.post<Equipment>(`/equipment/${id}/reactivate`),
};

export const categoriesService = {
  list: (includeInactive = false) => api.get<EquipmentCategory[]>('/equipment-categories', { includeInactive }),
  get: (id: string) => api.get<EquipmentCategory>(`/equipment-categories/${id}`),
  create: (input: EquipmentCategoryFormValues) => api.post<EquipmentCategory>('/equipment-categories', input),
  update: (id: string, input: Partial<EquipmentCategoryFormValues>) =>
    api.patch<EquipmentCategory>(`/equipment-categories/${id}`, input),
  remove: (id: string) => api.delete<RemovalResult>(`/equipment-categories/${id}`),
};
